import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission, Print } from 'utils';
import { Table, Pagination, Tooltip, Input, DatePicker, Select, Modal, Button } from 'components';
import { CleanIcon, AddIcon, EditIcon, TrashIcon, ChatIcon, DownloadExcelIcon } from 'assets/icons';
import ModalCreate from './modal-create';
import ModalViewChat from './modal-view-chat';
import { SanService } from 'services';
import moment from 'moment';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

declare var window: any;

const INITIAL_STATE = {
	search: '',
	city: '',
	since: '',
	until: '',
	country_id: ''
}

class San extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Fecha de creación',
			'Código del san',
			'Modalidad',
			'País',
			'Nº de participantes',
			'Monto del san',
			'Nº semanas, meses o quincenas',
			'Moneda',
			'Fecha de inicio',
			'Fecha de finalización',
			''
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		visible_chat: false,
		commission_percentage: 0,
		point_levels: [],
		currencies: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Creación de San',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await SanService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.sanes.rows,
			last_page: res.sanes.count,
			commission_percentage: res.commission_percentage || 0,
			point_levels: res.point_levels || [],
			currencies: res.currencies || []
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => {
			this.load(true);
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el SAN?',async () => {
			await SanService.admin.delete({
				san_id: item?.id
			});	
			Globals.showSuccess("Se ha eliminado el SAN correctamente");
			this.load(true);
		});
	}
	
	viewChat = async (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_chat: true,
			item
		});
	}

	downloadChat = async (e: any, item: any) => {
		e.preventDefault();
		const res: any = await SanService.admin.downloadChats({
			san_id: item?.id
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	onCloseChat = () => {
		this.setState({
			visible_chat: false,
			item: null
		});
	}

	download = async () => {
		if (!this.state.form.since || !this.state.form.until) {
			Globals.showWarning("Por favor, seleccione dos fecha para filtrar en un rango de 180 días");
			return;
		}

		if (moment(this.state.form.until).diff(moment(this.state.form.since),'days') > 180) {
			Globals.showWarning("El rango máximo a exportar es de 180 días");
			return;
		}

		const res: any = await SanService.admin.downloadAllChats({
			country_id: this.state.form.country_id,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}

	render() {
		const { visible, visible_chat } = this.state;
		const item: any = this.state.item;

		return (
			<div id="admin-san">
				<Modal
		          className="modal-create-san"
		          visible={ visible }
		          title={ `${ this.state.item != null ? 'Editar' : 'Creación de' } San ${ this.state.item != null ? ('Nº ' + item?.code) : '' }` }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		          	commission_percentage={ this.state.commission_percentage }
		          	item={ this.state.item }
		          	currencies={ this.state.currencies }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-chat"
		          visible={ visible_chat }
		          title={ `Chat del San Nº${ item?.code || '' }` }
		          onClose={ () => this.onCloseChat() }
		        >
		          {/*
		          // @ts-ignore */}
		          <ModalViewChat
		          	item={ this.state.item }
		            onClose={ () => this.onCloseChat() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="row col-md-10">
								<div className="col-md">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Código del san"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<Input
										value={ this.state.form.city }
										name="city"
										label="Ciudad"
										placeholder="Buscar"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
								<div className="col-md">
									<Select
										placeholder="Seleccionar"
										label="País"
										name="country_id"
										color="white"
										onChange={ (e: any) => this.change(e,async () => {
											this.load(true);
										}) }
										value={ this.state.form.country_id }
										options={ [
											{ value: Constants.COUNTRIES.VZLA.toString() , label: 'Venezuela' },
											{ value: Constants.COUNTRIES.COL.toString() , label: 'Colombia' }
										] } />
								</div>
							</div>
							<div className="col-md">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				{
					this.state.data.length > 0 && (
						<div className="text-right">
							<div className="container-add-table top">
								<p>Descargar Chats</p>
								<button className="btn add-btn-table" onClick={ this.download }>
									<img src={ DownloadExcelIcon } />
								</button>
							</div>
						</div>
					)
				}

				<Table title="Sanes Registrados" data={ this.state.data.length } header={ this.state.header } titleRight={
					<>
						{
							checkPermission(Constants.MODULES.SAN,'write') && (
								<div className="container-add-table">
									<p>Nuevo</p>
									<button className="btn add-btn-table" onClick={ this.add }>
										<img src={ AddIcon } />
									</button>
								</div>
							)
						}
					</>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i.code }</td>
								<td>{ i.modality?.name || '-' }</td>
								<td>{ i.country?.name || '-' }</td>
								<td>{ i.quantity_persons }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ Globals.formatMiles(i.amount,true,i.currency_symbol) }</td>
								<td>{ i.days_or_weeks } { i.frequency == Constants.FREQUENCIES.WEEK ? 'semana(s)' : i.frequency == Constants.FREQUENCIES.MONTH ? 'mes(es)' : 'quincena(s)' }</td>
								<td>{ i.currency?.name || '-' }</td>
								<td>{ i.start_date ? moment(i.start_date).format('DD/MM/YYYY') : '-' }</td>
								<td>{ i.finish_date ? moment(i.finish_date).format('DD/MM/YYYY') : '-' }</td>
								<td style={{ 'whiteSpace': 'nowrap' }}>
									{
										checkPermission(Constants.MODULES.SAN,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.SAN,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
									<Tooltip title="Ver Chat">
										<a className="link-icon" href="#" onClick={ (e: any) => this.viewChat(e,i) }>
											<img src={ ChatIcon } />
										</a>
									</Tooltip>
									<Tooltip title="Descargar Chat">
										<a className="link-icon download-chat" href="#" onClick={ (e: any) => this.downloadChat(e,i) }>
											<img src={ DownloadExcelIcon } />
										</a>
									</Tooltip>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(San);